import { CardDetailFragment } from 'generated/resources/graphql'

import { isActive } from './isActive'
import { isPhysical } from './isPhysical'

export const canViewSecretData = (card: CardDetailFragment): boolean => {
  return !isPhysical(card) && isActive(card) && card._policies?.createEphemeralKey?.can === true
}
